import React from 'react';
import { ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { buttonBaseStyles as buttons } from 'styles/designConstants';

const useStyles = makeStyles({
  root: {
    ...buttons.root,
    margin: (props: IOwnProps) => props.margin || 0,
    width: (props: IOwnProps) => props.width || 240,
  },
  // Button roles, as identified in the design palette
  primary: buttons.primary,
  secondary: buttons.secondary,
  negative: buttons.negative,
  dashboard: buttons.dashboard,
});

const ButtonMedium = (props: IOwnProps) => {
  const classes = useStyles(props);
  const {
    buttonRole,
    children,
    disabled,
    handleClick,
    buttonType = 'button',
  } = props;

  let buttonRoleStyle;
  switch (buttonRole) {
    case 'secondary':
      buttonRoleStyle = classes.secondary;
      break;
    case 'negative':
      buttonRoleStyle = classes.negative;
      break;
    default:
      buttonRoleStyle = classes.primary;
  }

  return (
    <ButtonBase
      data-testid={props['data-testid']}
      className={`${classes.root} ${buttonRoleStyle}`}
      onClick={(e) => handleClick && handleClick(e)}
      disabled={disabled}
      focusRipple
      type={buttonType}
    >
      {children}
    </ButtonBase>
  );
};

export interface IOwnProps {
  buttonRole: string; // chose from 'primary'(default), 'secondary', or 'negative'.
  buttonType?: 'button' | 'reset' | 'submit' | undefined;
  children: any;
  disabled?: boolean;
  fontSize?: string;
  margin?: string;
  'data-testid'?: string;
  width?: string;
  handleClick?: Function;
}

export default ButtonMedium;
